import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { ExitInterviews } from "../../shared/models/ExitInterviews";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSortHeader, MatSort, MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { UserService } from "../../shared/service/user.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { ExitAddDialogComponent } from "../exit-add-dialog/exit-add-dialog.component";
import {
  CdkDragDrop,
  CdkDropList,
  CdkDrag,
  moveItemInArray,
} from "@angular/cdk/drag-drop";

@Component({
  selector: "app-exit-interview-form",
  templateUrl: "./exit-interview-form.component.html",
  styleUrls: ["./exit-interview-form.component.css"],
})
export class ExitInterviewFormComponent implements OnInit {
  QuestionList: any;
  dataSourceFTE: MatTableDataSource<ExitInterviews>;
  check: boolean = false;
  loader: boolean = true;
  error: string;
  result: any;
  exitInterviews: ExitInterviews;
  quelist: any;
  LoginEmpCode: any;
  displayedColumns: string[] = ["Question", "CreatedBy", "Edit", "Delete"];
  permission: any;
  sortedList: any;

  @ViewChild(MatPaginator, { static: false }) paginatorFTE: MatPaginator;
  //@ViewChild(MatSort, { static: false }) sortFTE: MatSort;
  @ViewChild("input", { static: false }) input: ElementRef;

  constructor(
    private empsvc: EmployeeService,
    public router: Router,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private _userService: UserService
  ) {
    //this.LoginEmpCode = this.userService.getEmpCode();
    this.QuestionList = [];
    this.dataSourceFTE = new MatTableDataSource();
  }

  ngOnInit() {
    this.permission = this._userService.userInfo.permissions.find(
      (i) => i.Name === "Exit Interview Questions"
    );
    if (this.permission && this.permission.ReadOnlyPermission) {
      this.displayedColumns = ["Question", "CreatedBy"];
    }
    if (this.permission && this.permission.HasFullAccess) {
      this.displayedColumns = ["Question", "CreatedBy", "Edit", "Delete"];
    }
    this.LoginEmpCode = this.userService.getEmpCode();

    setTimeout(() => {
      this.loader = false;
    }, 1500);
    this.getExitQuestions();
    //this.dataSourceFTE = new MatTableDataSource();
    this.dataSourceFTE.filterPredicate = (
      data: ExitInterviews,
      filter: string
    ) => {
      return data.Question.toLowerCase().includes(filter);
    };
  }

  removeExtraSpaces(str) {
    return str.replace(/\s+/g, "").trim();
  }

  getExitQuestions() {
    this.empsvc.getExitInterviewQuestions().subscribe(
      (data: ExitInterviews[]) => {
        this.QuestionList = data;
        this.dataSourceFTE.data = this.QuestionList;

        if (this.paginatorFTE) {
          this.dataSourceFTE.paginator = this.paginatorFTE;
        }
        //if (this.sortFTE) {
        //  this.dataSourceFTE.sort = this.sortFTE;
        //}
      },
      (error) => {
        console.error("Error fetching exit interview questions", error);
        this.toastr.error("Failed to load questions");
      }
    );
  }

  //editQuestion(val) {
  //  val.isEditing = true;
  //}

  editQuestion(selectedElement) {
    this.QuestionList.forEach((element) => {
      element.isEditing = false;
    });
    selectedElement.isEditing = true;
  }

  deleteQuestion(val) {
    const message = `Are you sure you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(
      "",
      message,
      deleteType
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.loader = true;
          this.empsvc.deleteExitInterviewQuestions(val).subscribe(
            (data) => {
              this.toastr.success("Deleted Successfully.");
              //this.loader = false;
              this.getExitQuestions();

              window.scrollTo(0, 0);
              setTimeout(() => {
                this.loader = false;
              }, 1000);
            },
            (error) => {
              this.error = error;
              this.loader = false;
            }
          );
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
  }
  saveQuestion(element) {

    if (!element.Question || element.Question.trim() === "") {
      this.toastr.warning("Please enter the question here");
      return;
    }

    const message = `Are you sure you want to save this record?`;
    var deleteType = "Submit";
    const dialogData = new ConfirmDialogModel(
      "",
      message,
      deleteType
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.loader = true;

          if (element.isEditing) {
            element.ModifiedBy = this.LoginEmpCode;
          }

          if (element.Id == null || element.Id == "") {
            element.CreatedBy = this.LoginEmpCode;
          }

          this.empsvc.saveExitInterviewQuestions(element).subscribe(
            (data) => {
              if (element.isEditing == true) {
                this.toastr.success("Updated Successfully.");
              } else {
                this.toastr.success("Saved Successfully.");
              }
              element.isEditing = false;
              //this.loader = false;

              window.scrollTo(0, 0);
              setTimeout(() => {
                this.loader = false;
              }, 800);
              this.getExitQuestions();
            },
            (error) => {
              this.error = error;
              this.loader = false;
              this.toastr.error("Error saving question.");
            }
          );
        } else {
          element.isEditing = false;
          setTimeout(() => {
            this.loader = false;
          }, 800);
          this.getExitQuestions();
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
  }
  AddQuestion() {
    const dialogRef = this.dialog.open(ExitAddDialogComponent, {
      width: "1000px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const newQuestion: ExitInterviews = {
          Id: null,
          OffboardingId: null,
          EmpCode: null,
          EmployeeComments: null,
          Question: result,
          CreatedBy: this.LoginEmpCode,
          ModifiedBy: null,
          CreatedDate: new Date(),
          ModifiedDate: null,
          isEditing: false,
          SortOrder: null,
          IsEmpFeedbackSubmitted: false,
          ExitInterviewHRComments: null,
          IsEmpFeedbackRequired: false,
          IsHRCommentsSubmitted: false,
          IsRejected: false,
        };
        this.saveQuestion(newQuestion);
        this.dataSourceFTE.data = [newQuestion, ...this.dataSourceFTE.data];
        this.cdr.detectChanges();
        //this.dataSourceFTE._updateChangeSubscription();
      }
    });
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase();
    this.dataSourceFTE.filter = filterValue;
  }

  drop(event: CdkDragDrop<ExitInterviews[]>) {
    const previousIndex = this.dataSourceFTE.data.findIndex(
      (d) => d === event.item.data
    );

    if (previousIndex === -1) {
      console.error("Item not found in the data source.");
      return;
    }

    moveItemInArray(this.dataSourceFTE.data, previousIndex, event.currentIndex);
    this.dataSourceFTE.data = [...this.dataSourceFTE.data];

    const sortorder: ExitInterviews[] = this.dataSourceFTE.data.map(
      (item, index) => ({
        ...item,
        SortOrder: index + 1,
      })
    );

    this.empsvc.SaveInterviewQuestionSortOrder(sortorder).subscribe(
      (data: any) => {
        this.sortedList = data;
      },
      (error) => {
        console.error("Error fetching exit interview questions", error);
        this.toastr.error("Failed to load questions");
      }
    );
  }
}
